import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Autocomplete,
  CircularProgress,
  Backdrop,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Divider,
  Container,
  Box
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import moment from 'moment';
import Controls from '../controls/Controls';
import { useSettingContext } from '../../context/setting_context';
import { baseUrl, paymentMethod, controlAccounts } from '../../utils/constants';

export default function ExtraPayment() {
  const navigate = useNavigate();
  const { payCycles } = useSettingContext();
  const [paymentTo, setPaymentTo] = useState('provider');
  const [formData, setFormData] = useState({
    accountRefId: '',
    paymentDate: '',
    amountPaid: 0,
    processed: false,
    userRefId: 0,
    cycleId: 0,
    revenueAccount: 0,
    receiptType: 'Current',
    manualReceipt: '',
    paymentMethod: 'Cash',
    paidBy: ''
  });
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [revenues, setRevenues] = useState([]);

  const PaymentsSchema = Yup.object().shape({
    accountRefId: Yup.string().required('Please select Account, field is Required'),
    paymentDate: Yup.date().required('Please select Payment Date, field is Required'),
    termId: Yup.number()
      .min(1, 'Receipt Term is not selected')
      .required('Term Paid for is required'),
    amountPaid: Yup.string()
      .min(2, 'Amount Paid should be greater than 2')
      .required('Amount Paid is required'),
    revenueAccount: Yup.string()
      .min(2, 'Revenue Account not selected')
      .required('Revenue Account is required'),
    manualReceipt: Yup.string()
      .min(0, 'Manual Receipt Number should be greater than 0')
      .required('Manual Receipt Number is required'),
    paymentMethod: Yup.string().required('Method of Payment is required'),
    paidBy: Yup.string()
      .min(2, 'Paid By is too Short!')
      .max(50, 'Paid By is too Long!')
      .required('Paid By is required')
  });

  const formik = useFormik({
    initialValues: formData,
    enableReinitialize: true,
    validationSchema: PaymentsSchema,
    onSubmit: (values) => {
      savePayments(values);
    }
  });

  useEffect(() => {
    populateList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const savePayments = (e) => {
    const jsonClient = [];
    jsonClient.push(e);
    console.log('student stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/processPayments`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setFormData(result);
          console.log('returned Payments', result);
          setLoading(false);
          notifyPopup(`Payment Updated Successfully!`, 'success');
          navigate(-1);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in saving Payment!: ${error}`, 'error');
        }
      );
  };

  const populateList = async () => {
    setLoading(true);
    await axios(`${baseUrl}/api/claims/GetClaimsByStatus?status=5`).then(
      (result) => {
        console.log('returned GetClaimsByStatus', result);
        setList(result.data.result);
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        notifyPopup(`Error in getting students!: ${error}`, 'error');
      }
    );
  };

  const getRevenueAccounts = async (accountType) => {
    await axios(`${baseUrl}/api/accounting/GetAccountsByType?accountType=6`).then(
      (result) => {
        console.log('returned getRevenueAccounts info', result);
        setRevenues(result.data.result);
      },
      (error) => {
        notifyPopup(`Error in getting revenue!: ${error}`, 'error');
      }
    );
  };
  // const populateList2 = async (filter) => {
  //   await axios(
  //     `${baseUrl}/api/systemLookup/GetLookupList?systemLookupType=134&filter=${filter}&recordCount=5&filterRefId=1`
  //   ).then(
  //     (result) => {
  //       console.log('returned notes', result);
  //       setList(result.data.notesList);
  //     },
  //     (error) => {
  //       alert('failed');
  //     }
  //   );
  // };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const defprops = {
    options: list,
    // key: list.claim_ID,
    getOptionLabel: (options) => `${options.claim_ID} ${options.patientName} ${options.awardTotal}`
  };

  const { errors, touched } = formik;

  return (
    <Container>
      <Typography component="span" variant="h6" gutterBottom>
        Extra Payment
      </Typography>
      <Card>
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
                onClick={handleLoadingClose}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Typography variant="subtitle1" color="error">
                Process Single Payment
              </Typography>
              <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={5}>
                  <FormControl fullWidth>
                    <InputLabel id="selectDoc">Make Payment To:</InputLabel>
                    <Select
                      labelId="selectDoclabel"
                      id="docType"
                      value={paymentTo}
                      size="small"
                      variant="standard"
                      onChange={(e) => {
                        setPaymentTo(e.target.value);
                      }}
                    >
                      <MenuItem value="provider">Provider</MenuItem>
                      <MenuItem value="member">Member</MenuItem>
                      <MenuItem value="supplier">Supplier</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Autocomplete
                    {...defprops}
                    id="accountRefIds"
                    onChange={(e, value) => {
                      console.log('now selecte', value);
                      console.log('now e', e);
                      formik.setFieldValue('accountRefId', value.cif_Number);
                      formik.setFieldValue('amountPaid', value.awardTotal);
                      formik.setFieldValue('userRefId', sessionStorage.getItem('userRefId'));
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Pay to..." variant="standard" />
                    )}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={8}>
                  <Autocomplete
                    fullWidth
                    id="combo-box-demo"
                    getOptionLabel={(option) => option.provider}
                    options={list}
                    // sx={{ width: 300 }}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.claim_ID}>
                        {option.memberShipNo} {option.patientName} Total Amount: {option.awardTotal}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField {...params} label="Pay to..." variant="standard" />
                    )}
                  />
                </Grid> */}
                <Grid item xs={12} sm={2}>
                  <Controls.Input name="accountRefId" label="Account Ref#" disabled />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="manualReceipt" label="Manual Receipt #" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.DateTime name="paymentDate" label="Payment Date" />
                </Grid>
                <Divider
                  style={{ background: '#00000', height: 0, margin: 2, mt: '8px', width: '90%' }}
                  variant="middle"
                />
                <Grid item xs={12} sm={6} justifyContent="center" alignItems="center">
                  <Controls.Input name="amountPaid" label="Amount Paid" />
                </Grid>
                <Divider
                  style={{ background: '#00000', height: 0, margin: 2, mt: 2, width: '90%' }}
                  variant="middle"
                />
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel id="revLabel">Pay Cycle</InputLabel>
                    <Select
                      id="cycleId"
                      value={formik.values.cycleId}
                      name="cycleId"
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={(e) => {
                        formik.setFieldValue('cycleId', e.target.value);
                      }}
                      helperText={touched.cycleId ? errors.cycleId : ''}
                      error={touched.cycleId && Boolean(errors.cycleId)}
                    >
                      <MenuItem key="" value="0">
                        Not Selected
                      </MenuItem>
                      {payCycles.map((item) => (
                        <MenuItem key={item.payCycleId} value={item.payCycleId}>
                          {moment(item.payDate).format('MMM YYYY')}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.SelectJson
                    name="controlAcc"
                    label="Control Account"
                    options={controlAccounts}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.SelectJson
                    name="paymentMethod"
                    label="Payment Method"
                    options={paymentMethod}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="paidBy" label="Paid By" />
                </Grid>
                <Grid
                  margin={2}
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="right"
                >
                  <Grid item xs={12} sm={6}>
                    <Controls.CheckBox name="processed" label="Processed" disabled />
                  </Grid>
                  <Grid item xs={12} sm={1} marginRight={1}>
                    <Controls.Button type="submit" variant="contained" startIcon={<SaveIcon />}>
                      Save...
                    </Controls.Button>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
          <Controls.Notification notify={notify} setNotify={setNotify} />
        </CardContent>
      </Card>
    </Container>
  );
}
